<div style="background-color: white; padding: 30px; height: 100vh; overflow-x: scroll;">

  <h2>1. Terms & Conditions of Use</h2>

  <h3>1. Introduction</h3>
  <p>
    These Terms & Conditions <strong>("Terms")</strong> govern access to and use of the <strong>Payvider Platform ("Platform")</strong> operated by <strong>[Your Legal Entity Name]</strong>, having its registered office at <strong>[Address] ("Company", "we", "us")</strong>. By creating an account or using the Platform, the <strong>Hospital ("you")</strong> agree to be bound by these Terms.
  </p>

  <h3>2. Definitions</h3>
  <ul>
    <li><strong>Hospital</strong> – a healthcare provider onboarded as merchant of record to collect insurance claim payments.</li>
    <li><strong>Insurer / Payer</strong> – an insurance company or corporate or Volo Health Services that issues a virtual credit card to settle approved claims.</li>
    <li><strong>Virtual Card</strong> – a card token generated by Volo Health Services for a single claim payment on approval from Insurer / Payer.</li>
    <li><strong>Razorpay Services</strong> – payment processing services provided by Razorpay Software Private Limited.</li>
  </ul>

  <h3>3. Scope of Services</h3>
  <p>The Platform allows Hospitals to:</p>
  <ol>
    <li>View outstanding or approved insurance claims.</li>
    <li>Redeem virtual cards issued by Insurers through Razorpay’s payment gateway.</li>
    <li>Download MIS reports and settlement files.</li>
  </ol>

  <h3>4. Account Creation & Responsibilities</h3>
  <ul>
    <li>Hospitals must maintain accurate KYC, bank, and contact details.</li>
    <li>Login credentials are confidential; you are responsible for all activities under your account.</li>
    <li>You will use the Platform only for legitimate claim-settlement transactions and comply with IRDAI, RBI and other applicable regulations.</li>
  </ul>

  <h3>5. Payment Processing</h3>
  <ul>
    <li>Razorpay onboards each Hospital as "merchant on record".</li>
    <li>All card data entry, tokenization, and 2-factor authentication occur on Razorpay’s PCI-DSS compliant pages.</li>
    <li>Settlement will be made to the Hospital’s designated bank account T+1 (working day) after successful capture, subject to Razorpay’s settlement schedule.</li>
  </ul>

  <h3>6. Fees & Taxes</h3>
  <p>
    We may levy platform or convenience fees as notified on your dashboard. You authorize deduction of such fees from settlement amounts. Any applicable GST will be charged extra.
  </p>

  <h3>7. Cancellation & Refunds</h3>
  <p>
    Policy detailed in Clause 12 below.
  </p>

  <h3>8. Data Privacy</h3>
  <p>
    We handle data in accordance with our <strong>Privacy Policy</strong>. Razorpay independently processes card data as a separate data controller.
  </p>

  <h3>9. Prohibited Conduct</h3>
  <p>Hospitals may not:</p>
  <ul>
    <li>misuse virtual cards for purposes other than the specific claim;</li>
    <li>attempt to reverse-engineer the Platform;</li>
    <li>violate any applicable healthcare or data privacy laws (e.g., DISHA, PDP Act 2023).</li>
  </ul>

  <h3>10. Intellectual Property</h3>
  <p>
    All software, logos, and content are owned by the Company or its licensors. No rights are transferred except the limited license to use the Platform.
  </p>

  <h3>11. Limitation of Liability</h3>
  <p>
    To the maximum extent permitted by law, our cumulative liability shall not exceed the total fees paid by the Hospital in the <strong>preceding 3 months</strong>.
  </p>

  <h3>12. Cancellation, Returns & Refunds</h3>
  <ul>
    <li><strong>Cancellation</strong> – Hospitals may cancel a payment request before clicking “Redeem Now” (Once a transaction is authenticated, cancellation is no longer possible).</li>
    <li><strong>Refunds</strong> – If a duplicate charge or processing error occurs, contact support within <strong> 7 days</strong>. Refunds will be processed to the original virtual card within <strong>T+7 working days</strong> after validation. Platform fees are non-refundable.</li>
    <li>Detailed policy available at <strong>/refund-policy</strong>.</li>
  </ul>
    
  <h3>13. Indemnity</h3>
  <p>
    Hospitals shall indemnify the Company and Razorpay against losses arising from misuse of virtual cards, breach of these Terms, or violation of law.
  </p>

  <h3>14. Governing Law & Dispute Resolution</h3>
  <p>
    These Terms are governed by the laws of India. Courts in <strong>[city]</strong> shall have exclusive jurisdiction. Parties agree to attempt resolution via mediation before litigation.
  </p>

  <h3>15. Amendment</h3>
  <p>
    We may amend these Terms with <strong>15-days’ notice</strong> via email or dashboard alert.
  </p>

  <h3>16. Contact</h3>
  <p>
    Grievance Officer: <strong>[Name]</strong> – grievance@yourdomain.com | +91-XXX-XXX-XXXX
  </p>

  <h2>2. Privacy Policy</h2>
  <p>
    Published at <strong>/privacy-policy</strong><br>
    The policy aligns with India’s Digital Personal Data Protection Act 2023 (DPDPA) and RBI/PCI-DSS guidelines.
  </p>

  <h3>1. Purpose</h3>
  <p>
    This Privacy Policy explains how <strong>[Company]</strong> collects, uses, discloses and safeguards personal data when you use the Payvider Platform.
  </p>

  <h3>2. Data We Collect</h3>
  <table border="1" cellspacing="0" cellpadding="5">
    <thead>
      <tr>
        <th>Category</th>
        <th>Example</th>
        <th>Source</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>Hospital Information</td>
        <td>Name, PAN, GSTIN, bank a/c, contact person</td>
        <td>During onboarding</td>
      </tr>
      <tr>
        <td>User Credentials</td>
        <td>Email, phone, OTP logs, device metadata</td>
        <td>Login / usage</td>
      </tr>
      <tr>
        <td>Claim Data</td>
        <td>Claim ID, Insurer name, patient initials, approved amount</td>
        <td>Insurer API / manual upload</td>
      </tr>
      <tr>
        <td>Payment Data</td>
        <td>Transaction IDs, auth codes, masked card digits</td>
        <td>Razorpay webhooks</td>
      </tr>
      <tr>
        <td>Usage Analytics</td>
        <td>Pages visited, clickstream</td>
        <td>Cookies / SDK</td>
      </tr>
    </tbody>
  </table>

  <h3>3. Legal Bases</h3>
  <p>
    We process data under one or more of the following: performance of a contract, legitimate interest (fraud prevention, product improvement), and compliance with legal obligations.
  </p>

  <h3>4. How We Use Data</h3>
  <ul>
    <li>Display claim status and transaction history.</li>
    <li>Facilitate payment processing with Razorpay.</li>
    <li>Generate MIS reports for reconciliation.</li>
    <li>Detect and prevent fraud or misuse.</li>
    <li>Provide customer support and dispute resolution.</li>
  </ul>

  <h3>5. Data Sharing</h3>
  <p>We share necessary data with:</p>
  <ul>
    <li><strong>Razorpay</strong> – to process payments.</li>
    <li><strong>Insurers</strong> – to update claim status.</li>
    <li><strong>Volo Health Services</strong> – for using the platform and generate card.</li>
    <li>Government or regulatory bodies when required.</li>
  </ul>
  <p>We never sell personal data to third parties.</p>

  <h3>6. Security Measures</h3>
  <ul>
    <li>TLS 1.2 encryption in transit, AES-256 at rest.</li>
    <li>PCI-DSS level 1 certified payment processor (Razorpay).</li>
    <li>Role-based access control and logging.</li>
  </ul>

  <h3>7. Data Retention</h3>
  <p>
    Transaction and KYC records are retained for <strong>8 years</strong> per RBI master directions, after which they are securely deleted or anonymized.
  </p>

  <h3>8. User Rights</h3>
  <p>
    You may request access, correction, or deletion of your data by emailing <strong>privacy@yourdomain.com</strong>. Certain data required for statutory purposes cannot be deleted.
  </p>

  <h3>9. International Transfers</h3>
  <p>
    Our primary servers are in India. If data is processed abroad (e.g., Razorpay’s backup servers), we ensure equivalent protection via contractual safeguards.
  </p>

  <h3>10. Cookies & Similar Technologies</h3>
  <p>
    We use session cookies solely for authentication and analytics. You may disable cookies, but some features may not function.
  </p>

  <h3>11. Updates</h3>
  <p>
    Policy last updated on <strong>[Date]</strong>. Significant changes will be notified via dashboard.
  </p>

  <h3>12. Contact & Grievance Redressal</h3>
  <p>
    Data Protection Officer: <strong>[Name], dpo@yourdomain.com, +91-XXX-XXX-XXXX.</strong><br>
    Escalate unresolved complaints to the Data Protection Board of India.
  </p>

  <h2>3. Cancellation, Returns & Refund Policy</h2>
  <p>
    Publish at <strong>/refund-policy</strong>.<br>
    Razorpay will verify that this page exists and is reachable from the footer.
  </p>

  <h3>1. Scope</h3>
  <p>
    This policy applies to electronic claim-settlement payments made by Insurers using virtual credit cards via Razorpay.
  </p>

  <h3>2. Cancellation Before Payment</h3>
  <ul>
    <li>Hospitals can cancel a redemption request <strong>before</strong> submitting card details by clicking "Cancel" on the "Redeem Now" screen.</li>
    <li>No charges are levied for cancelled requests.</li>
  </ul>

  <h3>3. Failed / Duplicate Transactions</h3>
  <p>If a payment fails, times out, or is processed twice:</p>
  <ol>
    <li>Raise a ticket at <strong>support@yourdomain.com</strong> within <strong>7 calendar days</strong>.</li>
    <li>Provide the Claim ID, transaction reference(s), and screenshots if available.</li>
    <li>We will verify with Razorpay, and if validated, process a <strong>full reversal</strong> to the same virtual card within <strong>T+7 working days</strong>.</li>
  </ol>

  <h3>4. Refunds Post-Settlement</h3>
  <p>
    Because payments are corresponded to approved insurance claims, once settled to the Hospital’s bank account they are generally <strong>non-refundable</strong>. Exceptions may be made only if:
  </p>
  <ul>
    <li>The Insurer revokes approval in writing, <strong>and</strong></li>
    <li>The Hospital confirms services were not rendered. <br>
 Such cases require manual validation and may involve off-platform settlement between Hospital and Insurer.</li>
  </ul>

  <h3>5. Transaction Fees</h3>
  <p>
    Platform facilitation and Razorpay MDR are non-refundable unless the underlying transaction is fully reversed before settlement.
  </p>

  <h3>6. Chargebacks</h3>
  <p>
    All chargebacks initiated by the Insurer’s issuing bank will follow card-scheme rules. The Hospital must respond to document requests within <strong>3 working days</strong>.
  </p>

  <h3>7. Contact</h3>
  <p>
    Refund Desk: <strong>refunds@yourdomain.com | +91-XXX-XXX-XXXX</strong><br>
    Operational hours: <strong>Mon–Fri 10:00–18:00 IST (excluding public holidays)</strong>
  </p>

  <h2>How to Use These Templates</h2>
  <ol>
    <li>
      <strong>Replace placeholders</strong> ([Your Legal Entity Name], addresses, phone numbers, timeline preferences).
    </li>
    <li>
      <strong>Review compliance</strong> with your legal counsel—especially sections on healthcare data, RBI master directions (2021) and the Digital Personal Data Protection Act 2023.
    </li>
    <li>
      <strong>Host each document</strong> on a publicly accessible URL (e.g., https://payvider.in/terms). Add persistent footer links across all web pages and within the "Redeem Now" Razorpay Checkout (use prefill or theme options in the Razorpay script if embedding).
    </li>
    <li>
      Update version dates whenever you amend the documents.
    </li>
  </ol>

  <p>
    These templates meet the standard disclosure items Razorpay’s merchant-review team looks for—so once populated and published, they should help your gateway approval proceed smoothly.
  </p>

</div>